// extracted by mini-css-extract-plugin
export default {"clock":"style_clock__9cQaR","time":"style_time__4Y99w"};